import React from 'react';
import { CardProps } from '../../types';

const Card: React.FC<CardProps> = ({
  variant = 'default',
  size = 'md',
  children,
  className = '',
  onClick,
}) => {
  const baseClasses = 'rounded-lg transition-all duration-normal';
  
  const variantClasses = {
    default:
      'bg-white border-2 border-neutral-200 shadow-soft ring-1 ring-neutral-900/[0.04] hover:border-neutral-300 hover:shadow-soft-md hover:ring-neutral-900/[0.06]',
    elevated:
      'bg-white border-2 border-neutral-200 shadow-soft-md ring-1 ring-neutral-900/[0.05] hover:shadow-soft-lg hover:border-neutral-300',
    outlined: 'bg-white border-2 border-neutral-300 hover:border-neutral-400 shadow-soft',
  };
  
  const sizeClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };
  
  const interactiveClasses = onClick
    ? 'cursor-pointer hover:-translate-y-1'
    : '';
  
  const classes = `
    ${baseClasses}
    ${variantClasses[variant]}
    ${sizeClasses[size]}
    ${interactiveClasses}
    ${className}
  `.trim();
  
  return (
    <div
      className={classes}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
};

export default Card;
